import { ColumnsInterface } from "./columns.interface";
import { FilterMatchMode } from "primeng/api";

export function Column<T>(meta?:  Partial<ColumnsInterface<T>>) {
  return function(target: any, propertyKey: string) {
    if (!target.constructor._props) {
      target.constructor._props = [];
    }
    const columnMeta : ColumnsInterface<T> = {
      field: meta?.field ? meta.field : propertyKey,
      fieldPath: meta?.fieldPath ? meta.fieldPath : propertyKey,
      filterType: meta?.filterType,
      filterMatchMode: meta?.filterMatchMode ? meta.filterMatchMode :  FilterMatchMode.CONTAINS,
      header: meta?.header ? meta.header : propertyKey,
    }
    target.constructor._columns = [...(target.constructor._columns || []), columnMeta]
  }
}
